import React, { useState, useEffect } from "react"
import { Button } from "@mui/material"
import CircularProgress from "@mui/material/CircularProgress"
import StarIcon from "@mui/icons-material/Star"
import StarOutlineIcon from "@mui/icons-material/StarOutline"
import Typography from "@mui/material/Typography"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import {
  getReviewsByMemberId,
  pubReview,
  cancelPubReview,
} from "services/review"
import { verifyResponse } from "utils/httpRequest"
import { StyledMemberReviews } from "./Member.style"
import moment from "moment"

const MemberReviews = ({ memberId }) => {
  const [reviews, setReviews] = useState([])
  const [reviewLoading, setReviewLoading] = useState(false)
  const [reviewStatusLoading, setReviewStatusLoading] = useState(0)

  const loadMemberReviews = async () => {
    setReviewLoading(true)
    try {
      const response = await getReviewsByMemberId(memberId)
      verifyResponse(response)
      setReviews(response.data.list || [])
    } finally {
      setReviewLoading(false)
    }
  }

  useEffect(() => {
    loadMemberReviews()
  }, [memberId])

  const changeReviewPubStatus = async (review) => {
    setReviewStatusLoading(review.id)
    try {
      if (review.pubStatus === 0) {
        await pubReview(review.id)
      } else {
        await cancelPubReview(review.id)
      }
      await loadMemberReviews()
    } finally {
      setReviewStatusLoading(0)
    }
  }

  if (reviewLoading && reviewStatusLoading === 0) {
    return (
      <Card className="review-card">
        <CardContent>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            <CircularProgress />
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <StyledMemberReviews>
      {reviews.length === 0 ? (
        <div className="reviews-empty">No reviews available for this member yet.</div>
      ) : (
        reviews.map((review) => {
          return (
            <div className="review" key={`review-item-${review.id}`}>
              <Card className="review-card">
                <CardContent>
                  <div>
                    <div className="review-rate">
                      Rate:{" "}
                      {Array.from(Array(review.star)).map((_, idx) => {
                        return (
                          <StarIcon
                            key={`star-icon-${review.id}-${idx}`}
                          />
                        )
                      })}
                      {Array.from(Array(5 - review.star)).map((_, idx) => {
                        return (
                          <StarOutlineIcon
                            key={`star-outline-icon-${review.id}-${idx}`}
                          />
                        )
                      })}
                    </div>
                  </div>
                  <div className="review-time">
                    {moment(review.createdAt).format("LLL")}
                  </div>
                  <Typography className="review-content" variant="body2">
                    {review.content}
                  </Typography>
                </CardContent>
                <CardActions className="review-actions">
                  {reviewStatusLoading === review.id ? (
                    <CircularProgress />
                  ) : (
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        changeReviewPubStatus(review)
                      }}
                    >
                      {review.pubStatus === 0 ? "Publish" : "Unpublish"}
                    </Button>
                  )}
                </CardActions>
              </Card>
            </div>
          )
        })
      )}
    </StyledMemberReviews>
  )
}

export default MemberReviews
